
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import Icone from '@/core/components/UI/Icone.vue';
import ManualPreenchimentoInspecao from '@/models/Constantes/ManualPreenchimentoInspecao';
import { IInspecaoSecao2 } from '@/models/Entidades/IInspecao';

export default defineComponent({
  name: 'InspecaoSecao2',
  props: {
    secao2: {
      type: Object as () =>IInspecaoSecao2,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    Icone,
  },
  emits: ['update:secao2', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
      manuaisPreenchimento: {} as Record<string, boolean>,
    });

    const computedSecao2 = computed({
      get: () => props.secao2,
      set: (valor: IInspecaoSecao2) => {
        emit('update:secao2', valor);
      },
    });

    function change() {
      emit('change');
    }

    function alternarManualPreenchimento(chave: string) {
      state.manuaisPreenchimento[chave] = !state.manuaisPreenchimento[chave];
    }

    return {
      props,
      computedSecao2,
      state,
      change,
      ManualPreenchimentoInspecao,
      alternarManualPreenchimento,
    };
  },
});
